import { createSelector } from 'reselect'

import { emptyObj } from 'util/objects'
import { isAdmin, isOwner } from 'util/agents'

const selectBase = state => {
  return state.currentUser || emptyObj
}

export const selectCurrentUser = state => selectBase(state) || emptyObj

export const selectCurrentUserId = state => selectCurrentUser(state).id

export const selectCurrentUserGlobalId = state => {
  const id = selectCurrentUserId(state)
  return id ? `ag_${id}` : id
}

export const selectCurrentUserIsAdmin = createSelector(
  selectCurrentUser,
  agent => isAdmin(agent)
)

export const selectCurrentUserIsOwner = createSelector(
  selectCurrentUser,
  agent => isOwner(agent)
)

export const selectCurrentUserCanAccessAdmin = createSelector(
  selectCurrentUserIsAdmin,
  state => state.app && state.app.account && state.app.account.subdomain,
  (admin, subdomain) => {
    return admin && (subdomain === 'groove' || subdomain === 'supportguy')
  }
)

export const selectCurrentUserHasFullAccess = createSelector(
  selectCurrentUser,
  agent => !!agent.fullAccess
)
